<mat-card>
	<mat-card-header>
		<mat-card-title *ngIf="isLoading" class="loading-width">
			Loading
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab [mat-dialog-close]="true">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
		<mat-card-title *ngIf="!isLoading">
			{{data.chosenRegion ? 'Region ' + data.chosenRegion.CODE : ''}}
			{{data.chosenSchoolDistrict ? data.chosenSchoolDistrict.DISTRICTS : ''}}
			{{data.eligibilityCategoryType ? '(' + data.eligibilityCategoryType.TYPE + ')' : ''}}

			<div>
				{{(searchResultDataSource ?
				(searchResultDataSource.filteredData.length < results.length ?
					searchResultDataSource.filteredData.length + '/' : '' ) : '' ) + results.length}} Child(ren) </div>

					<button class="close-button" mat-mini-fab [mat-dialog-close]="true">
						<mat-icon>close</mat-icon>
					</button>
					<mat-divider></mat-divider>
		</mat-card-title>
	</mat-card-header>
	<mat-dialog-content *ngIf="!isLoading">
		<div class="row">
			<mat-form-field class="col-lg-12">
				<mat-label>
					Filter
				</mat-label>
				<input matInput id="filter" name="filter" type="string" [(ngModel)]="searchResultFilter"
					(ngModelChangeDebounced)="setFilter(searchResultDataSource, searchResultFilter)" />
			</mat-form-field>
		</div>
		<div class="table-responsive">
			<mat-table [dataSource]="searchResultDataSource" class="mat-elevation-z1" matSort>
				<ng-container matColumnDef="MSD_NUMBER">
					<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
							[displayText]="element.MSD_NUMBER">
						</edit-child-modal-btn>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SSID">
					<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.NAME}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="DOB">
					<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.DOB | cleanDate | simpleDate}} {{element.DOB |
						cleanDate | age}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SEX">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SEX}}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"
					[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
					[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
					[matTooltipPosition]="'above'"
					[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
					[matTooltipClass]="'terminatedTooltip'">
				</mat-row>
			</mat-table>
		</div>

		<div mat-dialog-actions class="pull-right" *ngIf="!isLoading">
			<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20, 100]" showFirstLastButtons
				aria-label="Select page of periodic elements">
			</mat-paginator>
		</div>
	</mat-dialog-content>
</mat-card>